import React from "react";
interface TooltipProps {
  children: React.ReactNode;
  tooltip: React.ReactNode;
  enabled?: boolean;
}

/**
 * A component to display a visual icon link to access the site map editing interface. It
 * allows actions to be called before navigating (i.e. saving data).  It also will render
 * the site map thumbnail and display a loading interface if it's not yet rendered.  It will
 * poll in the background if the thumbnail is not yet rendered.
 */
export const Tooltip = ({
  tooltip,
  children,
  enabled = true,
}: TooltipProps) => {
  return (
    <div className="has-tooltip">
      {children}
      {enabled ? <span className="tooltip-text">{tooltip}</span> : null}
    </div>
  );
};
